import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Reusable Components
import SubTitleContents from "reusables/TextFormats/SubTitleContents";

// Reusable Components
import CheckList_TwoColumns from "reusables/TextFormats/CheckList_TwoColumns";

// Images

function OneOff_Section4() {
  const titlesDescriptionsObj = {
    "Before or after a special event": "",
    "Seasonal deep cleaning (e.g., spring cleaning)": "",
    "Preparing a property for guests or new occupants": "",
    "Restoring order after a renovation or move": "",
  };
  return (
    <Container>
      <Grid container alignItems="center">
        <Grid item display={"flex"} flexDirection={"column"}>
          <Grid item>
            <SubTitleContents title="When to Use One-Off Cleaning Services?" contents="" />
          </Grid>
          <Grid item>
            <CheckList_TwoColumns titlesDescriptionsObj={titlesDescriptionsObj} />
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}

export default OneOff_Section4;
